import { Navigate } from "react-router-dom";

export default function FundamentalAnalysisPage() {
  return <Navigate to="/discipline-manager" replace />;
}
